module.exports = __webpack_public_path__ + "media/honey-icons/icon-photo-4df84ab3.svg";